'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactServerStatus = require('react-server-status');

var _reactServerStatus2 = _interopRequireDefault(_reactServerStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorMessage = function ErrorMessage(_ref) {
    var message = _ref.message,
        statusCode = _ref.statusCode,
        theme = _ref.theme;
    return _react2.default.createElement(
        _reactServerStatus2.default,
        { status: statusCode },
        _react2.default.createElement(
            'div',
            { className: theme.error },
            _react2.default.createElement(
                'h1',
                null,
                'Oops!'
            ),
            _react2.default.createElement(
                'p',
                null,
                message
            )
        )
    );
};

ErrorMessage.propTypes = {
    message: _propTypes2.default.string.isRequired,
    statusCode: _propTypes2.default.number,
    theme: _propTypes2.default.shape({
        error: _propTypes2.default.string
    })
};

ErrorMessage.defaultProps = {
    statusCode: 404,
    theme: {}
};

exports.default = ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-error-message/lib/cjs/ErrorMessage.js
 ** module id = 644
 ** module chunks = 1
 **/